/**
 *
 * 分屏操作
 *
 * 功能点:分屏展示
 * 场景:方案演示
 * 版本 1.0
 * 初始map 为.mars3d-container
 * 关于新map只显示隐藏着色？
 */
import Vue from "@/main";

/**
 * 模型变量
 * @var mapClone - 克隆的地图
 * @var mapOldOptions - 老地图参数
 */
export let mapClone;
export let mapOldOptions;
let currSkyBox;
let lantianSkybox;
let qingtianSkybox;
let wanxiaSkybox;

/**
 * 初始化 现在所有的操作都是针对老地图
 * @returns { any } - 创建出克隆的map对象
 */
export function open(data) {
  if (mapClone) {
    mapClone.show = true;
    setTimeout(() => {
      if (typeof data != "string") {
        console.log("分屏数据", data);
        $(".el-main")
          .addClass(data.splitScreenMode)
          .addClass(`percentage-${data.splitScreenModePercentage}`);
        screenplay.performAction(data.mainScreen[0]);
        screenplay.performAction(data.secondaryScreen[0]);
      } else {
        console.log("分屏数据", data);

        $(".el-main")
          .addClass(JSON.parse(data).splitScreenMode)
          .addClass(`percentage-${JSON.parse(data).splitScreenModePercentage}`);

        screenplay.performAction(JSON.parse(data).mainScreen[0]);
        screenplay.performAction(JSON.parse(data).secondaryScreen[0]);
      }
    }, 0);
  } else {
    mapOldOptions = Vue.$GLOBAL.map.getCurrentOptions();
    // mapOld = $("#mars3d-container")[0];
    if (typeof data == "string") {
      $(".el-main")
        .addClass(JSON.parse(data).splitScreenMode)
        .addClass(`percentage-${JSON.parse(data).splitScreenModePercentage}`);
    } else {
      $(".el-main")
        .addClass(data.splitScreenMode)
        .addClass(`percentage-${data.splitScreenModePercentage}`);
    }
    // console.log("分屏数据", JSON.stringify(mapOldOptions));

    mapOldOptions.control.baseLayerPicker = false; // basemaps底图切换按钮
    mapOldOptions.control.homeButton = false; // 视角复位按钮
    mapOldOptions.control.sceneModePicker = false; // 二三维切换按钮
    mapOldOptions.control.navigationHelpButton = false; // 帮助按钮
    mapOldOptions.control.infoBox = false; // 信息框
    mapOldOptions.control.selectionIndicator = false; // 选择框
    mapOldOptions.control.vrButton = false; // vr模式按钮
    mapOldOptions.control.fullscreenButton = false; // 全屏按钮
    mapOldOptions.control.animation = false; // 动画部件按钮
    mapOldOptions.control.timeline = false; // 时间线
    mapOldOptions.control.geocoder = false;

    let mapOldOptionsLayersArr = [];
    mapOldOptions.layers.forEach((item) => {
      // 处理逻辑？删除
      if (
        item.type == "xyz" ||
        Vue.$GLOBAL.osgbTilesetLayerIds.indexOf(item.modelId) >= 0
      ) {
        if (item.style) item.style = null;
        mapOldOptionsLayersArr.unshift(item);
      }
    });

    mapOldOptions.layers = mapOldOptionsLayersArr;

    if (Vue.$GLOBAL.map.terrainProvider._layers != undefined) {
      mapOldOptions.terrain = {
        show: true,
        url: Vue.$GLOBAL.map.terrainProvider._layers[0].resource._url,
        requestVertexNormals: true,
        requestMetadata: true,
      };
    }

    mapClone = new mars3d.control.MapCompare({
      ...mapOldOptions,
      parentContainer: $("#mars3d-container").parent()[0],
    });

    Vue.$GLOBAL.map.addControl(mapClone);
    Vue.$GLOBAL.mapClone = mapClone._mapEx;
    Vue.$GLOBAL.mapClone.viewer.scene.highDynamicRange = false; //是否关闭高动态范围渲染(不关闭时地图会变暗)。
    Vue.$GLOBAL.mapClone.viewer.scene.shadows = false; //是否开启日照阴影。
    Vue.$GLOBAL.mapClone.viewer.scene.globe.enableLighting = false; //是否显示昼夜区域

    //展示蓝天天空盒代码

    lantianSkybox = new mars3d.GroundSkyBox({
      sources: {
        positiveX: "/img/skybox_near/lantian/Right.jpg",
        negativeX: "/img/skybox_near/lantian/Left.jpg",
        positiveY: "/img/skybox_near/lantian/Front.jpg",
        negativeY: "/img/skybox_near/lantian/Back.jpg",
        positiveZ: "/img/skybox_near/lantian/Up.jpg",
        negativeZ: "/img/skybox_near/lantian/Down.jpg",
      },
    });
    qingtianSkybox = new mars3d.GroundSkyBox({
      sources: {
        positiveX: "/img/skybox_near/qingtian/rightav9.jpg",
        negativeX: "/img/skybox_near/qingtian/leftav9.jpg",
        positiveY: "/img/skybox_near/qingtian/frontav9.jpg",
        negativeY: "/img/skybox_near/qingtian/backav9.jpg",
        positiveZ: "/img/skybox_near/qingtian/topav9.jpg",
        negativeZ: "/img/skybox_near/qingtian/bottomav9.jpg",
      },
    });

    wanxiaSkybox = new mars3d.GroundSkyBox({
      sources: {
        positiveX: "/img/skybox_near/wanxia/SunSetRight.png",
        negativeX: "/img/skybox_near/wanxia/SunSetLeft.png",
        positiveY: "/img/skybox_near/wanxia/SunSetFront.png",
        negativeY: "/img/skybox_near/wanxia/SunSetBack.png",
        positiveZ: "/img/skybox_near/wanxia/SunSetUp.png",
        negativeZ: "/img/skybox_near/wanxia/SunSetDown.png",
      },
    });

    let defaultSkybox; // cesium自带的Skybox
    let defaultBgColor = Vue.$GLOBAL.mapClone.scene.backgroundColor;
    defaultSkybox = Vue.$GLOBAL.mapClone.scene.skyBox;

    const skyBox = JSON.parse(localStorage.getItem("skyBoxSettings")).skyBox;
    switch (skyBox) {
      case "0":
        currSkyBox = lantianSkybox;
        break;
      case "1":
        currSkyBox = qingtianSkybox;
        break;
      case "2":
        currSkyBox = wanxiaSkybox;
        break;
      default:
        currSkyBox = lantianSkybox;
        break;
    }

    Vue.$GLOBAL.mapClone.addEffect(
      new mars3d.effect.BrightnessEffect({
        enabled: true,
        brightness: Vue.$GLOBAL.brightnessEffect.brightness,
      })
    );

    Vue.$GLOBAL.mapClone.on(mars3d.EventType.postRender, function () {
      var position = Vue.$GLOBAL.mapClone.camera.position;

      var height = Cesium.Cartographic.fromCartesian(position).height;
      if (height < 230000) {
        if (currSkyBox) {
          Vue.$GLOBAL.mapClone.scene.skyBox = currSkyBox;
          Vue.$GLOBAL.mapClone.scene.backgroundColor = Cesium.Color.LIGHTBLUE;
        }
        // 改成false 幅屏天空盒子就生效了
        Vue.$GLOBAL.mapClone.scene.skyAtmosphere.show = false;
      } else {
        let atmosphericRenderingShow = window.sessionStorage.getItem(
          "atmosphericRenderingShow"
        );
        if (defaultSkybox) {
          Vue.$GLOBAL.mapClone.scene.skyBox = defaultSkybox;
          Vue.$GLOBAL.mapClone.scene.backgroundColor = defaultBgColor;
        }
        if (!atmosphericRenderingShow) {
          Vue.$GLOBAL.mapClone.scene.skyAtmosphere.show = true;
        }
      }
    });
    Vue.$GLOBAL.mapClone.on(mars3d.EventType.load, () => {
      // // 初始化完成
      window.mapClone = Vue.$GLOBAL.mapClone;
      Vue.$GLOBAL.map._viewer.camera.percentageChanged = 0.0001;
      Vue.$GLOBAL.mapClone._viewer.camera.percentageChanged = 0.0001;
      Vue.$GLOBAL.mapClone.scene.msaaSamples =
        Vue.$GLOBAL.map.scene.msaaSamples;
      setTimeout(() => {
        if (typeof data != "string") {
          screenplay.performAction(data.mainScreen[0]);
          screenplay.performAction(data.secondaryScreen[0]);
        } else {
          console.log("分屏初始化完成", JSON.parse(data).mainScreen[0]);
          screenplay.performAction(JSON.parse(data).mainScreen[0]);
          screenplay.performAction(JSON.parse(data).secondaryScreen[0]);
        }
      }, 0);

      if (Vue.$GLOBAL.map.getTileLayers().length > 0) {
        // 瓦片透明度
        let opacity = Vue.$GLOBAL.map.getTileLayers()[0]._opacity;
        // 瓦片亮度
        let brightness = Vue.$GLOBAL.brightnessEffect.brightness;
        // 瓦片对比度
        let contrast = Vue.$GLOBAL.map.getTileLayers()[0].contrast;
        // 瓦片色彩
        let hue = Vue.$GLOBAL.map.getTileLayers()[0].hue;
        // 瓦片饱和度
        let saturation = Vue.$GLOBAL.map.getTileLayers()[0].saturation;
        // 瓦片伽马值
        let gamma = Vue.$GLOBAL.map.getTileLayers()[0].gamma;

        Vue.$GLOBAL.mapClone.getTileLayers().forEach((item) => {
          item.opacity = opacity;
          // item.brightness = brightness;
          item.contrast = contrast;
          item.hue = hue;
          item.saturation = saturation;
          item.gamma = gamma;
        });
      }
    });
  }
}

export function init() {
  $("#mars3d-container.mars3d-mapCompare").remove();
  $(".el-main")
    .removeClass("upDown")
    .removeClass("leftRight")
    .removeClass("percentage-50")
    .removeClass("percentage-100");
  if (
    mapClone &&
    mapClone != "undefined" &&
    Vue.$GLOBAL.map.controls.mapCompare
  ) {
    Vue.$GLOBAL.map.controls.mapCompare.mapEx.getLayers().forEach((i) => {
      if (i.type != "xyz") {
        i.destroy();
      }
    });

    $("#mars3d-container")[0].style.width = "100%";
    // Vue.$GLOBAL.map.removeControl(mapClone);
    mapClone.show = false;
    // $(".mars3d-container.mars3d-mapCompare").remove();
    Vue.$GLOBAL.map._viewer.camera.percentageChanged = 0.001;
  } else {
    Vue.$GLOBAL.map._viewer.camera.percentageChanged = 0.001;
  }
}

export function skyBoxToUpdate(type = "1") {
  switch (type) {
    case "0":
      currSkyBox = lantianSkybox;
      break;
    case "1":
      currSkyBox = qingtianSkybox;
      break;
    case "2":
      currSkyBox = wanxiaSkybox;
      break;
    default:
      currSkyBox = lantianSkybox;
      break;
  }
}
